module.exports = __webpack_public_path__ + "static/media/img-legal.d59032fe.svg";